var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7817 11.912C9.85718 12.5692 8.7298 12.8777 7.5995 12.7828C6.46919 12.688 5.40898 12.196 4.60688 11.394C3.80477 10.592 3.3126 9.53181 3.21764 8.40151C3.12267 7.27121 3.43106 6.14381 4.0881 5.21921L10.7817 11.9136V11.912ZM11.9129 10.7808L5.2193 4.08801C6.14386 3.43041 7.27148 3.12158 8.40209 3.2163C9.5327 3.31102 10.5932 3.80317 11.3955 4.60543C12.1977 5.4077 12.6899 6.4682 12.7846 7.59882C12.8793 8.72943 12.5705 9.85704 11.9129 10.7816V10.7808ZM14.4001 8.00001C14.4001 9.69739 13.7258 11.3253 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3253 1.6001 9.69739 1.6001 8.00001C1.6001 6.30262 2.27438 4.67476 3.47461 3.47452C4.67485 2.27429 6.30271 1.60001 8.0001 1.60001C9.69748 1.60001 11.3253 2.27429 12.5256 3.47452C13.7258 4.67476 14.4001 6.30262 14.4001 8.00001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/Ban.030cac53dbdb6d18f7b96ec6aa5d6e4b.svg";
export { ForwardRef as ReactComponent };